// cleanup_convert_to_typescript_file_GENERICS

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, SMALL, TERTIARY } from '@glu/buttons-react';

import axios from 'components/axios/AxiosFactory';
import Snackbar from 'components/snackbar/Snackbar';
import useLocale from 'components/useLocale';
import { setSnackbarVisibility, setInterceptorsAdded } from 'logic/store/userEmulation/actions';

import useStyles from './UserEmulationFlowError.styles';

export const CommonErrorSnackbarComponent = () => {
  const locale = useLocale();
  const classes = useStyles();
  const { interceptorsAdded, isSnackbarVisible: visible } = useSelector(
    ({ userEmulation }) => userEmulation
  );
  const dispatch = useDispatch();
  const { dismissBtn, root } = classes;

  const handleSnackbarVisibility = (value) => {
    dispatch(setSnackbarVisibility(value));
  };

  if (!interceptorsAdded) {
    axios.setupCommonErrorInterceptors(handleSnackbarVisibility);
    dispatch(setInterceptorsAdded(true));
  }

  return (
    <Snackbar
      error
      show={visible}
      message={locale['userEmulation.flowError']}
      className={root}
      classes={classes}
      dataQa="userEmulationFlowError-snackbar"
      action={
        <Button
          dataQa="userEmulationFlowError-dismiss-button"
          className={dismissBtn}
          variant={TERTIARY}
          size={SMALL}
          onClick={() => {
            handleSnackbarVisibility(false);
          }}
        >
          {locale['common.dismiss']}
        </Button>
      }
      zIndex={2000}
    />
  );
};

export default CommonErrorSnackbarComponent;
